<template>
	<div class="your-campaign">
		<!-- BIG SLOGAN -->
		<div class="container">
			<h1 class="mb-30">{{ $t("project.yourCampaign") }}</h1>
			<p class="crowd-or-rais"><span class="domore-blue-1">CROWDFUNDING</span></p>
		</div><!-- .container -->

    <!-- FORM -->
    <crowdfunding-form :project.sync='project' :submit='submit' :errors='errors' :alert='alert'></crowdfunding-form>

		<!-- STAR BOX -->
		<div class="container mt-50 mb-50">
			<p class="center"><img src="~assets/img/star.png"></p>
		</div><!-- .container .mt-50 .mb-50 -->
	</div>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
// Components
import CrowdfundingForm from '@/views/Crowdfunding/Form';
// Mixins
import alert from '@/mixins/alert';

export default {
  mixins: [alert],
  components: { CrowdfundingForm },
  data() {
    return {
      project: {
        crowdfunding: true,
        category_id: '',
        country_id: '',
        translation: { locale: localStorage.getItem('lang') },
        translations: [{ locale: localStorage.getItem('lang') }],
        video_url: '',
        photo: {},
      },
      submit: {
        action: this.saveProject,
        processing: false,
      },
    };
  },
  methods: {
    saveProject() {
      this.clearAlerts();
      this.submit.processing = true;
      projectsApi.new(this.project).then((response) => {
        this.submit.processing = false;
        this.$set(this.project, 'id', response.data.id);
        this.project.translation = response.data.translations.find(t =>
          t.locale === this.project.translation.locale,
        );
        this.project.translations = response.data.translations;
        this.alert.success = this.$t('project.form.newProjectSuccessAlert');
      })
      .catch((response) => {
        this.submit.processing = false;
        this.alert.error = this.$t('errors.incorrectData');
        const errors = response.response.data;
        this.errors = errors;
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?bd14751e